import { SvgIcon, SvgIconProps } from '@mui/material'
import { FC } from 'react'
export const ArrowDownIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      width="9"
      height="12"
      viewBox="0 0 9 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.00054 0.666687C5.00054 0.534079 4.94786 0.406902 4.85409 0.313134C4.76032 0.219365 4.63315 0.166687 4.50054 0.166687C4.36793 0.166687 4.24075 0.219365 4.14698 0.313134C4.05322 0.406902 4.00054 0.534079 4.00054 0.666687V6.83335H0.500537C0.40171 6.83344 0.305126 6.86281 0.222982 6.91776C0.140838 6.97271 0.0768199 7.05076 0.0390124 7.14207C0.00120478 7.23338 -0.00869613 7.33385 0.0105601 7.43078C0.0298164 7.52771 0.0773659 7.61676 0.147204 7.68669L4.1472 11.6867C4.24095 11.7803 4.36804 11.8329 4.50054 11.8329C4.63304 11.8329 4.76012 11.7803 4.85387 11.6867L8.85387 7.68669C8.92371 7.61676 8.97126 7.52771 8.99051 7.43078C9.00977 7.33385 8.99987 7.23338 8.96206 7.14207C8.92425 7.05076 8.86024 6.97271 8.77809 6.91776C8.69595 6.86281 8.59936 6.83344 8.50054 6.83335H5.00054V0.666687Z"
        fill="black"
      />
    </SvgIcon>
  )
}
